import React from 'react'
import { Text } from '../../../components/ui'

export const DataTypes = () => {
  return <Text>TBD</Text>
}
